/**
 * Tramits reducer.
 * @module reducers/tramits/tramits
 */

import { GET_TRAMITS } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  data: [],
};

/**
 * Tramits reducer.
 * @function tramits
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export default function tramits(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_TRAMITS}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_TRAMITS}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: action.result.items || [],
      };
    case `${GET_TRAMITS}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        data: [],
      };
    default:
      return state;
  }
}